import { rem, transparentize } from "polished";
import styled from "styled-components";

export const TextArea = styled.textarea`
  resize: none;
  border: 1px solid ${({ theme }) => theme.colors.sectionBorder};
  border-radius: ${rem(4)};
  outline-color: ${({ theme }) => theme.colors.vividBlue};

  &::placeholder {
    color: ${({ theme }) => transparentize(0.5, theme.colors.lightSecondary)};
  }

  &:hover {
    border-color: ${({ theme }) => theme.colors.hoverBorder};
  }
`;
